import React from 'react';
import tpl from '../templates/pbp';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import {apiback} from '../../../config';
import PayByPartsModel from '../models/payByParts.m';
import Model from '../models/installmentFromStatement-new.m';
import {canUseDOM} from '../../../helpers/canUseDOM';
import {withSSRData} from '../../../helpers/hoc/withSSRData';

class Pbp extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            paymentPart: 'payment_part',
            installmentFromStatement: 'installment_plan',
            tab: 'pbp',
            modelPbp: null,
            modelInstallment: null,
            partnerTab: 'partner-21',
            partnersData: null,
            widgets_2: []
        };

        this.sliderRefPartners = React.createRef();
        this.sliderRefPartnersInstallment = React.createRef();
    }

    togglePartnerTab = tab => {
        this.setState({partnerTab: tab});
    };

    toggleTab = tab => {
        const refByTab = {
            pbp: this.sliderRefPartners,
            installment: this.sliderRefPartnersInstallment
        };
        const activeSwiper =
            refByTab[this.state.tab] &&
            refByTab[this.state.tab].current &&
            refByTab[this.state.tab].current.swiper;

        const currentIndex = activeSwiper ? activeSwiper.activeIndex : 0;

        this.setState({tab}, () => {
            const refs = [this.sliderRefPartners, this.sliderRefPartnersInstallment];
            refs.forEach(ref => {
                const swiper = ref.current && ref.current.swiper;
                if (swiper) {
                    swiper.slideTo(currentIndex, 0);
                    swiper.update();
                }
            });
        });
    };

    componentWillMount() {
        if (canUseDOM) return;
        const ssrData = this.props.ssrData;
        if (ssrData) {
            this.setState({
                widgets: ssrData.widgets || [],
                widgets_2: ssrData.widgets_2 || [],
                partnersData: ssrData.partnersData || [],
                loader: false
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/credit/pbp_deferral',
            widgetKey: 'widgets_2'
        });
        Promise.all([
            fetch(apiback('PAYMENT_PART')).then(res => res.json()),
            fetch(apiback('PAYMENT_PART_TERMS')).then(res => res.json()),
            fetch(apiback('INSTALLMENT_PLAN')).then(res => res.json())
        ]).then(([pbp, terms, installment]) => {
            const pbpModel = new PayByPartsModel(
                pbp.data[this.state.paymentPart],
                this.state.paymentPart
            );

            pbpModel.setRealRateList(pbp.data.real_yearly_bet);
            pbpModel.setBankMonthCommission(terms.data);

            const installmentModel = new Model(
                installment.data[this.state.installmentFromStatement],
                this.state.installmentFromStatement
            );

            this.setState({
                modelPbp: pbpModel,
                modelInstallment: installmentModel
            });
        });
        fetch(apiback('PAY_BY_PARTS_PARTNERS'))
            .then(res => res.json())
            .then(response => {
                const partnersOnly = Object.values(response).filter(
                    item => typeof item === 'object' && item.id
                );
                this.setState({partnersData: partnersOnly});
            });
    }

    static displayName = 'Credit.Views.PayByParts';
}

export default withSSRData(Pbp);
